module.exports = __webpack_public_path__ + "img/icon-group3.0688a2c2.png";